import { render, staticRenderFns } from "./GroupTrackClient.vue?vue&type=template&id=195e60de&scoped=true&"
import script from "./GroupTrackClient.vue?vue&type=script&lang=js&"
export * from "./GroupTrackClient.vue?vue&type=script&lang=js&"
import style0 from "./GroupTrackClient.vue?vue&type=style&index=0&id=195e60de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e60de",
  null
  
)

export default component.exports